/* MXDVS sheet drag, assets/mxdvs-sheet-drag.js (09.10.2026). Phones only (under 990px wide).
   A panel follows the finger downwards and closes once it is dragged past 25% of its height or flicked down
   (faster than 0.6px per ms); a shorter pull snaps back in 280ms. The close button keeps working.
   Inside a panel that is scrolled down, a pull scrolls first; the drag starts once the panel is at its top
   (the grab bar on top is drawn by the panel's own CSS).
   Shared helper: the product panels use it now (size chart, Notify me, washing instructions); the menu and cart can later.
   Use: MxSheetDrag.attach(panelEl, { close: fn, backdrop: el, closePct: 25, flick: 0.6, snapMs: 280 }) */
(function () {
  if (window.MxSheetDrag) return;
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function attach(el, o) {
    o = o || {};
    var pct = (o.closePct || 25) / 100, flick = o.flick || 0.6, snap = o.snapMs || 280;
    var y0 = 0, dy = 0, lastY = 0, lastT = 0, v = 0, on = false, armed = false;
    function phone() { return window.innerWidth < 990; }
    function set(y) {
      el.style.transform = y > 0 ? 'translateY(' + y + 'px)' : '';
      if (o.backdrop) o.backdrop.style.opacity = y > 0 ? String(Math.max(0, 1 - y / (el.offsetHeight || 1))) : '';
    }
    function start(y, target) {
      if (!phone()) { armed = false; return; }
      armed = el.scrollTop <= 0 || !!(target && target.closest && target.closest('[data-sheet-grab]'));
      y0 = lastY = y; lastT = performance.now(); dy = 0; v = 0; on = false;
    }
    function move(y, e) {
      if (!armed) return;
      var d = y - y0;
      if (!on) {
        if (d > 6 && el.scrollTop <= 0) { on = true; el.classList.add('is-drag'); }
        else if (d < -6) { armed = false; return; }
        else return;
      }
      if (e.cancelable) e.preventDefault();
      dy = Math.max(0, d);
      var now = performance.now(); v = (y - lastY) / Math.max(1, now - lastT); lastY = y; lastT = now;
      set(dy);
    }
    function end() {
      if (!on) { armed = false; return; }
      on = armed = false; el.classList.remove('is-drag');
      var h = el.offsetHeight || 1;
      if (dy > h * pct || v > flick) {
        el.style.transition = RM ? 'none' : 'transform ' + Math.round(snap * 0.9) + 'ms cubic-bezier(.2,.8,.2,1)';
        el.style.transform = 'translateY(' + h + 'px)';
        setTimeout(function () {
          if (o.close) o.close();
          /* wait until the closed panel is hidden before putting its position back */
          setTimeout(function () { el.style.transition = 'none'; set(0); void el.offsetWidth; el.style.transition = ''; }, 400);
        }, RM ? 0 : snap);
      } else {
        el.style.transition = RM ? 'none' : 'transform ' + snap + 'ms cubic-bezier(.2,.8,.2,1)';
        set(0);
        setTimeout(function () { el.style.transition = ''; }, snap);
      }
    }
    el.addEventListener('touchstart', function (e) { start(e.touches[0].clientY, e.target); }, { passive: true });
    el.addEventListener('touchmove', function (e) { move(e.touches[0].clientY, e); }, { passive: false });
    el.addEventListener('touchend', end, { passive: true });
    el.addEventListener('touchcancel', end, { passive: true });
    return {
      set: function (k, val) { if (k === 'closePct') pct = val / 100; if (k === 'flick') flick = val; if (k === 'snapMs') snap = val; }
    };
  }
  window.MxSheetDrag = { attach: attach };
})();
